<div class="accounting-report-container">


  <div class="pageHeader" id="reportsHeader">
    <span>Reports</span>
  </div>

  <div class="ui-g daily-reports-container">
    <div class="ui-g-3 lableright glypha-font"> Daily Reports:	</div>
    <div class="ui-g-6">
      <div class="select-style">
        <fm-select
          (onChange)="reportChange('Daily Report')"
          ariaLabelledBy="default"
         [options]="dailyReports"
          scrollHeight = "550px"
          [(ngModel)]="selectedReport"
        ></fm-select>
      </div>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-3 lableright glypha-font"> Monthly Reports:	</div>
    <div class="ui-g-6">
      <div class="select-style">
        <fm-select
          (onChange)="reportChange('Monthly Report')"
          ariaLabelledBy="default"
          [options]="monthlyReports"
          scrollHeight = "550px"
          [(ngModel)]="selectedReport"
        ></fm-select>
      </div>
    </div>
  </div>

  <div class="ui-g adhoc-reports-container">
    <div class="ui-g-3 lableright glypha-font"> Adhoc Reports:	</div>
    <div class="ui-g-6">
      <div class="select-style">
        <fm-select
          (onChange)="reportChange('Adhoc Reports')"
          ariaLabelledBy="default"
          [options]="adhocReports"
          [(ngModel)]="selectedReport"
        ></fm-select>
      </div>
    </div>
  </div>

</div>
